import React from "react";
import styled from "styled-components/macro";

const ButtonContainer = styled.button`
  position: relative;

  /* Adapt the colours based on primary prop */
  background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;
  color: #131235;
  cursor: pointer;
  font-size: 0.8125rem;
  font-family: "Source Sans Pro semibold", "Arial", sans-serif;
  width: auto;

  padding: 0.5em 1em;
  display: ${(props) => (props.display ? props.display : "")};
  border: 1px solid #131235;
  margin-right: ${(props) => (props.list ? "1rem" : "0")};
  transition: all ${(props) => props.theme.transitionSpeed} linear;
  &:hover {
    background: ${(props) =>
      props.primary
        ? props.theme.surfaceAlt
        : props.danger
        ? props.theme.dangerAlt
        : props.theme.surfaceAlt};
  }
  &:disabled {
    opacity: 0.3;
    cursor: auto;
    background: ${(props) =>
      props.primary
        ? props.theme.onSurfaceLight
        : props.danger
        ? props.theme.danger
        : props.theme.onSurfaceLight};
  }
`;

const ButtonCenter = styled.div`
  width: 100%;
  text-align: center;
`;

const ButtonInner = styled.div`
  display: flex;
  align-items: center;
`;

const ButtonIcon = styled.div`
  margin-right: ${(props) => (props.iconBump ? ".5rem" : "")};
`;

const Secondary = (props) => {
  const IconComponent = props?.icon ?? null;

  return props.center ? (
    <ButtonCenter>
      <ButtonContainer {...props}>
        <ButtonInner>
          {IconComponent && (
            <ButtonIcon iconBump={props.iconBump}>
              <IconComponent />
            </ButtonIcon>
          )}
          {props.children}
        </ButtonInner>
      </ButtonContainer>
    </ButtonCenter>
  ) : (
    <ButtonContainer {...props}>
      <ButtonInner>
        {IconComponent && (
          <ButtonIcon iconBump={props.iconBump}>
            <IconComponent />
          </ButtonIcon>
        )}
        {props.children}
      </ButtonInner>
    </ButtonContainer>
  );
};

export default Secondary;
